export default "__VITE_ASSET__m0_fkBDX__"